import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PermissionEnum, Response } from '@ui/src';
import { messagesApi, PermissionResponse } from './services';

export interface MessagesDictionariesState {
  activePermissions?: PermissionEnum[];
  transactionTypes?: { name: string; id: string }[];
  whitelabel?: {
    data: {
      value: Record<string, string>;
    };
  };
}

const initialState: MessagesDictionariesState = {};

export const messagesDictionariesSlice = createSlice({
  name: 'messagesDictionaries',
  initialState,
  reducers: {
    setActivePermissions: (state, action: PayloadAction<PermissionEnum[]>) => {
      state.activePermissions = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      messagesApi.endpoints.getMessagingTransactionTypes.matchFulfilled,
      (
        state,
        action: PayloadAction<Response<{ name: string; id: string }>>,
      ) => {
        state.transactionTypes = action.payload.data.edges.map(
          (item) => item.node,
        );
      },
    );
    builder
      .addMatcher(
        messagesApi.endpoints.getMessagesPermissions.matchFulfilled,
        (state, action: PayloadAction<{ data: PermissionResponse }>) => {
          state.activePermissions = action.payload.data.permissions;

          localStorage.setItem(
            'activePermissions',
            JSON.stringify(action.payload.data.permissions),
          );
        },
      )
      .addMatcher(
        messagesApi.endpoints.getMessagingWhitelabel.matchFulfilled,
        (
          state,
          action: PayloadAction<{
            data: {
              data: {
                value: Record<string, string>;
              };
            };
          }>,
        ) => {
          state.whitelabel = action.payload.data;
        },
      );
  },
});

export const { setActivePermissions } = messagesDictionariesSlice.actions;

export default messagesDictionariesSlice.reducer;
